import { render } from "./ClientOfferDetail.vue?vue&type=template&id=638f33fb&scoped=true"
import script from "./ClientOfferDetail.vue?vue&type=script&lang=js"
export * from "./ClientOfferDetail.vue?vue&type=script&lang=js"

import "./ClientOfferDetail.vue?vue&type=style&index=0&id=638f33fb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638f33fb"]])

export default __exports__